'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCalculator = function IoIosCalculator(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.5 5c1.4 0 2.5 1.1 2.5 2.5v25c0 1.4-1.1 2.5-2.5 2.5h-17.5c-1.4 0-2.5-1.1-2.5-2.5v-25c0-1.4 1.1-2.5 2.5-2.5h17.5z m-0.6 16.9h-3.8v10h3.8v-10z m0-6.3h-3.8v3.8h3.8v-3.8z m-6.3 12.5h-3.7v3.8h3.7v-3.8z m0-6.2h-3.7v3.7h3.7v-3.7z m0-6.3h-3.7v3.8h3.7v-3.8z m-6.2 12.5h-3.8v3.8h3.8v-3.8z m0-6.2h-3.8v3.7h3.8v-3.7z m0-6.3h-3.8v3.8h3.8v-3.8z m-3.8-3.7h16.3v-3.8h-16.3v3.8z' })
        )
    );
};

exports.default = IoIosCalculator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-calculator.js
// module id = 2580
// module chunks = 168707334958949